// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"452":"9cfc5b16","749":"81ba852c"}[chunkId] + ".1779326379769.chunk.css";
};